import React, { useState } from 'react';
import {
  Col, Grid, Nav, Panel, Row,
} from 'rsuite';
import { PRICES_UPDATE_URL, STOCKS_UPDATE_URL } from '../api/products';
import FileUploadCsv from '../components/FileUploadCsv';
import { importB2bPrices } from '../api/b2b/b2b';
import AvailabilityUpload from '../components/Availability/AvailabilityUpload';
import AllegroPriceRules from '../components/PricingRules/AllegroPriceRules';

enum Tab {
  STOCK = 'STOCK',
  HANDLING_TIME = 'HANDLING_TIME',
  PRICE = 'PRICE',
  B2B_PRICE = 'B2B_PRICE',
  ALLEGRO_PRICE_RULES = 'ALLEGRO_PRICE_RULES',
}

function getAccept(tab: Tab): '.xlsx' | '.csv' {
  if (tab === Tab.B2B_PRICE) {
    return '.xlsx';
  }

  return '.csv';
}

export default function UpdateStocksAndPrices() {
  const [activeTab, setActiveTab] = useState<Tab>(Tab.STOCK);
  const accept = getAccept(activeTab);

  function resolveTarget(tab: Tab): string {
    switch (tab) {
      case Tab.STOCK:
      case Tab.HANDLING_TIME: {
        return STOCKS_UPDATE_URL;
      }
      case Tab.PRICE: {
        return PRICES_UPDATE_URL;
      }
      default:
        return '';
    }
  }

  function isUploadWithoutReport(tab: Tab): boolean {
    return tab === Tab.B2B_PRICE;
  }

  async function uploadFile(file: Blob) {
    const data = new FormData();
    data.append('attachment', file);

    switch (activeTab) {
      case Tab.B2B_PRICE: {
        const response = await importB2bPrices(data)
          .then(() => ({ data: {} }));
        return response.data;
      }
      default:
        return undefined;
    }
  }

  function renderContent() {
    if (activeTab === Tab.ALLEGRO_PRICE_RULES) {
      return <AllegroPriceRules />;
    }

    if (isUploadWithoutReport(activeTab)) {
      return (
        <FileUploadCsv
          className="mt-5"
          getUploadResult={(file) => uploadFile(file)}
          accept={[accept]}
        />
      );
    }

    return <AvailabilityUpload target={resolveTarget(activeTab)} />;
  }

  return (
    <Panel>
      <Grid fluid>
        <Row>
          <Col xs={24}>
            <Nav
              appearance="subtle"
              activeKey={activeTab}
              onSelect={(tab: Tab) => setActiveTab(tab)}
            >
              <Nav.Item eventKey={Tab.STOCK} key={Tab.STOCK}>
                Stock
              </Nav.Item>
              <Nav.Item eventKey={Tab.HANDLING_TIME} key={Tab.HANDLING_TIME}>
                Handling time
              </Nav.Item>
              <Nav.Item eventKey={Tab.PRICE} key={Tab.PRICE}>
                Prices
              </Nav.Item>
              <Nav.Item eventKey={Tab.B2B_PRICE} key={Tab.B2B_PRICE}>
                B2B prices
              </Nav.Item>
              <Nav.Item eventKey={Tab.ALLEGRO_PRICE_RULES} key={Tab.ALLEGRO_PRICE_RULES}>
                Allegro price rules
              </Nav.Item>
            </Nav>
          </Col>
        </Row>
        <Row>
          <Col xs={24}>
            {renderContent()}
          </Col>
        </Row>
      </Grid>
    </Panel>
  );
}
